// Public Routes
export const ADMIN_ROOT = 'admin';

// Internal Routes
export const SPACE_ANALYTICS = 'space-analytics';
export const SPACE_MANAGEMENT = 'space-management';
